import { CUSTOM_ELEMENTS_SCHEMA, Component, ElementRef, HostListener, OnInit, inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { AuthService } from 'src/app/service/auth.service';
import { WebViewInteropService } from 'src/app/service/web-view-interop.service';
import { AboutDialogComponent } from '../dialog/about-dialog/about-dialog.component';
import { SettingsDialogComponent } from '../dialog/settings-dialog/settings-dialog.component';
import { AlertService } from 'src/app/service/alert.service';

type MenuDialog = 'none' | 'info' | 'settings';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.css'],
    imports: [AboutDialogComponent, SettingsDialogComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MenuComponent implements OnInit {
  isMenuActive = false;
  activeDialog: MenuDialog = 'none';
  isAuthenticated = false;

  constructor(
    private elementRef: ElementRef,
    private authService: AuthService,
    private webViewInterop: WebViewInteropService,
    private oidcService: OidcSecurityService,
    private alertService: AlertService
  ) {
  }

  ngOnInit(): void {
    this.oidcService.isAuthenticated$.subscribe(result => {
      if (result.isAuthenticated) {
        this.isAuthenticated = true;
      }
    });
  }

  @HostListener('document:click', ['$event.target'])
  clickOutside(target: any) {
    if (!this.elementRef.nativeElement.contains(target)) {
      this.closeMenu();
    }
  }

  toggleMenu() {
    this.isMenuActive = !this.isMenuActive;
  }

  closeMenu() {
    this.isMenuActive = false;
  }

  openDialog(dialog: MenuDialog) {
    this.activeDialog = dialog;
    this.closeMenu();
  }

  closeDialog() {
    this.activeDialog = 'none';
  }

  closeApp() {
    this.webViewInterop.postMessageToClient("closeAppEvent");
    this.closeMenu();
  }

  logout() {
    this.authService.logoutAll();
    this.isAuthenticated = false;
  }
}